var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceAmounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b2b2b;}.cls-2{fill:#e30613;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.86,92.89c25.71,0,46.55-7,46.55-18.1s-20.84-20-46.55-20-46.55,9-46.55,20,20.84,18.1,46.55,18.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,74.79c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20V74.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.25,123.92C99.25,135,120.09,142,145.8,142s46.55-7,46.55-18.11-20.84-20-46.55-20-46.55,9-46.55,20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.8,144c-25.71,0-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.76c0,11.07-20.84,20-46.55,20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,137.29c0,11.06-20.84,20-46.55,20s-46.55-9-46.55-20V145c0,11.07,20.84,20.05,46.55,20.05s46.55-9,46.55-20.05v-7.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,150.65c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.75c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,164c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.76c0,11.06,20.84,20,46.55,20s46.55-9,46.55-20V164Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,177.37c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,190.73c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.76Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.35,204.09c0,11.07-20.84,20-46.55,20s-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.76Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.8,237.49c-25.71,0-46.55-9-46.55-20v7.76c0,11.07,20.84,20,46.55,20s46.55-9,46.55-20v-7.76c0,11.07-20.84,20-46.55,20Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,187c0,11.07,20.84,20,46.55,20h.64v-7.76h-.64c-25.71,0-46.55-9-46.55-20V187Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,173.6c0,11.07,20.84,20,46.55,20h.64v-7.76h-.64c-25.71,0-46.55-9-46.55-20v7.76Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,160.24c0,11.06,20.84,20,46.55,20h.64v-7.76h-.64c-25.71,0-46.55-9-46.55-20v7.76Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,146.88c0,11.06,20.84,20,46.55,20h.64v-7.76h-.64c-25.71,0-46.55-9-46.55-20v7.76Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.14,153.56h.64v-7.76h-.64c-25.71,0-46.55-9-46.55-20v7.75c0,11.07,20.84,20.05,46.55,20.05Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,125.76c0,11.07,20.84,18.1,46.55,18.1h.64V123.92c0-6.72,4.31-12.77,12.23-17.42a104.21,104.21,0,0,0-12.87-.78c-25.71,0-46.55,9-46.55,20Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.31,95.91a8.89,8.89,0,0,0,.42,2.65,91.25,91.25,0,0,1,9.28,1.83c-6.07-3.39-9.7-7.63-9.7-12.24v7.76Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,88.15c0,11.07-20.84,20-46.55,20A97.9,97.9,0,0,1,185,105.61c5.16,2.74,9,6,11.26,9.71a105.87,105.87,0,0,0,11.6.63c25.71,0,46.55-9,46.55-20V88.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,101.51c0,11.07-20.84,20-46.55,20-3.19,0-6.3-.13-9.31-.4a15.11,15.11,0,0,1,.26,2.77v5q4.4.38,9.05.38c25.71,0,46.55-9,46.55-20v-7.76Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,114.87c0,11.07-20.84,20-46.55,20q-4.65,0-9.05-.38v7.76q4.4.38,9.05.38c25.71,0,46.55-9,46.55-20v-7.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,128.23c0,11.07-20.84,20.05-46.55,20.05-3.1,0-6.12-.14-9.05-.39v7.76q4.4.38,9.05.38c25.71,0,46.55-9,46.55-20v-7.76Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,141.6c0,11.06-20.84,20-46.55,20-3.1,0-6.12-.14-9.05-.38V169c2.93.25,5.95.39,9.05.39,25.71,0,46.55-9,46.55-20.05V141.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,155c0,11.06-20.84,20-46.55,20-3.1,0-6.12-.14-9.05-.38v7.75c2.93.25,5.95.39,9.05.39,25.71,0,46.55-9,46.55-20V155Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,168.32c0,11.07-20.84,20-46.55,20q-4.65,0-9.05-.38v7.76c2.93.24,5.95.38,9.05.38,25.71,0,46.55-9,46.55-20v-7.76Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,181.68c0,11.07-20.84,20-46.55,20q-4.65,0-9.05-.38v7.76c2.93.24,5.95.38,9.05.38,25.71,0,46.55-9,46.55-20v-7.76Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.86,215.08q-4.65,0-9.05-.38v7.76q4.4.38,9.05.38c25.71,0,46.55-9,46.55-20V195c0,11.07-20.84,20-46.55,20Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceAmounts);
export default __webpack_public_path__ + "static/media/FinanceAmounts.e6cca11affc92c986416b8200bc60639.svg";
export { ForwardRef as ReactComponent };